import { InjectionToken } from '@angular/core';
import { Sentry } from '../models';

export const SENTRY = new InjectionToken<Sentry>('Sentry');
